export { default } from './useGetLowInventory';
